import { render, staticRenderFns } from "./OfferHistory.vue?vue&type=template&id=afa4855a&scoped=true"
import script from "./OfferHistory.vue?vue&type=script&lang=ts"
export * from "./OfferHistory.vue?vue&type=script&lang=ts"
import style0 from "./OfferHistory.vue?vue&type=style&index=0&id=afa4855a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa4855a",
  null
  
)

export default component.exports